/**
 * What someone sees at an address that isn't a page — a mistyped link, or an
 * old bookmark. Without this the router printed its own bare "Not Found".
 */
import { useNavigate } from '@tanstack/react-router'
import { MapPinOff } from 'lucide-react'
import { navItems } from '@/components/app/nav-config'
import { Page } from '@/components/page'
import { EmptyState } from './data-states'

/** The first page's name, so the way back says where it goes. */
export const startPageTitle = navItems.find((item) => item.url === '/')?.title ?? 'the start'

export function NotFound() {
  const navigate = useNavigate()
  return (
    <Page>
      <EmptyState
        icon={MapPinOff}
        title="Page not found"
        action={{ label: `Go to ${startPageTitle}`, onClick: () => navigate({ to: '/' }) }}
      />
    </Page>
  )
}
